var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 546,
    height: 529,
    viewBox: "0 0 546 529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "246.69 393.69 250.39 522.91 72.72 518.5 72.02 384.01"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.74,
    height: 174.93,
    x: 157.976,
    y: 301.371,
    fill: "#7C7C82",
    transform: "rotate(-86.83 159.346 388.836)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E5",
    d: "M122.93,298.55 C122.93,298.55 -17.38,394.73 71.9,401 L72.43,422.62 C72.43,422.62 116.67,434 117.5,443.57 C118.33,453.14 99.15,456.14 99.15,456.14 C99.15,456.14 117.95,459.89 116.15,467.94 C114.35,475.99 95.31,476.3 95.31,476.3 C95.31,476.3 116.45,486.97 110.74,492.09 C105.03,497.21 87.57,493.52 87.57,493.52 C87.57,493.52 106.98,510.89 98.63,514.52 C90.28,518.15 -125.73,374.42 109.39,273.36 L122.93,298.55 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3AA",
    d: "M109.39,273.36 C104.95,275.26 100.7,277.19 96.59,279.12 L107.23,310 C116.48,303 122.93,298.57 122.93,298.57 L109.39,273.36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E5",
    d: "M117.5,443.57 C116.67,434.02 72.43,422.66 72.43,422.66 L71.9,401 C12.14,396.78 55.24,352.3 90.28,323.34 L67.56,294.43 C-97.35,393.21 90.85,517.83 98.63,514.43 C106.98,510.81 87.57,493.43 87.57,493.43 C87.57,493.43 105.02,497.11 110.74,492 C116.46,486.89 95.31,476.21 95.31,476.21 C95.31,476.21 114.31,475.9 116.15,467.85 C117.99,459.8 99.15,456.05 99.15,456.05 C99.15,456.05 118.33,453.12 117.5,443.57 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3AA",
    d: "M360.92,219.38 C362.5,215.38 408.92,87.59 392.56,64.95 C376.2,42.31 342.24,66.24 342.24,66.24 L330.24,38.41 C330.24,38.41 384.84,8.84 407.79,35.91 C430.74,62.98 393.45,196.74 393.45,196.74 L497.67,227 C497.67,227 540.75,86.78 521.34,69.41 C501.93,52.04 473.8,69.49 473.8,69.49 L462,37.56 C462,37.56 523.08,13.78 541.59,47.4 C560.1,81.02 509,271 509,271 L360.92,219.38 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5859",
    d: "M239,254.7 C239,254.7 344.68,273.78 350.57,210.7 L525.2,269.38 C525.2,269.38 440.06,430.84 255.86,350.73 L239,254.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA444C",
    d: "M480.69,254.42 C470.77,279.53 456.09,302.27 431.61,319.26 C376.01,357.56 309.27,352.39 251.48,325.87 L255.86,350.73 C440.06,430.84 525.2,269.38 525.2,269.38 L480.69,254.42 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA444C",
    d: "M239,254.7 L255.89,350.7 C283.41,362.7 308.72,369.25 331.89,371.77 L312.59,252.35 C280.2,262.14 239,254.7 239,254.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E5",
    d: "M81.93,175.33 L248.69,160.24 L268.81,356 C268.81,356 104.75,422.72 81.93,175.33 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5859",
    d: "M248.69 160.24C248.69 160.24 164.44 214.92 105.69 197.24 46.94 179.56 44.69 95.67 87.79 75.93 130.89 56.19 133 111.8 133 111.8 133 111.8 155.12 88.46 167.33 96.85 183.24 107.79 170.33 131.65 170.33 131.65 170.33 131.65 237.94 123.7 248.69 160.24zM248.69 160.24C248.69 160.24 213.59 194.79 222.54 212.99 231.49 231.19 258.77 237.66 258.77 237.66L248.69 160.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA444C",
    d: "M248.69,160.24 C248.69,160.24 245.94,162.94 242.18,167.24 L241,230.57 C246.625345,233.643271 252.602194,236.023937 258.8,237.66 L248.69,160.24 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M115,261 L151.76,256.4 C151.76,256.4 142.81,238.2 128.23,241.82 C113.65,245.44 115,261 115,261 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.17,259.68 C127.17,259.68 128.17,252.28 133.69,252.58 C139.21,252.88 140.62,258.32 140.62,258.32 L127.17,259.68 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M184.05,247.52 L220.81,242.92 C220.81,242.92 211.86,224.73 197.28,228.34 C182.7,231.95 184.05,247.52 184.05,247.52 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M196.23,246.25 C196.23,246.25 197.23,238.85 202.76,239.15 C208.29,239.45 209.68,244.89 209.68,244.89 L196.23,246.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E5",
    d: "M258.69,237.82 L298.84,217.15 C298.84,217.15 302.57,242.46 288.84,250.55 C275.11,258.64 258.69,237.82 258.69,237.82 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M204.26,306 C204.26,306 212.5,314.21 223.84,309.31 C235.18,304.41 228.12,291.84 236.09,287.86 C244.06,283.88 262,314.76 233,329 C204,343.24 191.25,317.7 193.86,309.29 C195.89,302.54 201.68,303.81 204.26,306 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M236.09,287.85 C228.09,291.85 235.17,304.39 223.84,309.3 C212.51,314.21 204.26,306 204.26,306 C201.68,303.82 195.89,302.55 193.81,309.28 C192.99,311.91 193.68,316.28 195.9,320.48 L248.56,310.48 C250.82,297.62 241.31,285.24 236.09,287.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E5",
    d: "M331.6,331.84 C331.6,331.84 353,421 247.45,415.66 L248.45,441.46 C248.45,441.46 215.28,446.27 213.4,455.67 C211.52,465.07 230.26,470.19 230.26,470.19 C230.26,470.19 211.12,471.84 212,480 C212.88,488.16 231.79,490.61 231.79,490.61 C231.79,490.61 209.6,498.88 214.72,504.61 C219.84,510.34 237.58,508.61 237.58,508.61 C237.58,508.61 216.37,523.74 224.27,528.25 C232.17,532.76 416.6,488.65 354.67,331.75 L331.6,331.84 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3AA",
    d: "M354.69,331.76 L331.6,331.84 C333.18528,339.562689 333.723449,347.463677 333.2,355.33 L363.69,360.65 C361.445961,350.800578 358.436829,341.141264 354.69,331.76 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M319.94,346.13 L375.94,341.13 C375.94,341.13 358.22,292.57 335.05,294 C311.88,295.43 319.94,346.13 319.94,346.13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M431.31 82L460.81 76.65C460.81 76.65 460.06 24.25 423.68.13L443.26 64 427.26 66.61 431.31 82zM311.8 79.74L334.91 69.67C334.91 69.67 324.18 26.92 289.74 14.2L318.11 62.74 305.55 68 311.8 79.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA444C",
    d: "M136.91,184.7 C119.79,184.7 106.48,178.48 97.7,166.18 C88.01,152.62 83.22,140.18 83.44,129.33 C83.61,121.01 86.9,113.82 92.44,109.6 C97.44,105.83 103.12,105.42 105.69,108.6 C112.3,116.85 110.81,143.6 110.69,144.7 L108.69,144.58 C108.69,144.31 110.21,117.51 104.08,109.85 C102.23,107.54 97.63,108.12 93.6,111.17 C83.77,118.6 79.35,137.17 99.24,164.99 C112.3,183.28 134.94,187.49 166.51,177.51 C190.25,169.99 210.37,156.82 210.57,156.68 L211.67,158.35 C211.46,158.49 191.15,171.8 167.15,179.4 C156.13,183 146,184.7 136.91,184.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA444C",
    d: "M147.8 166.51C143.141988 166.545269 138.567916 165.270074 134.6 162.83 129.6 159.83 127.12 154.96 127.28 148.83 127.59 137.49 137.51 123.13 145.52 118.83 148.84 117.03 150.91 117.5 152.06 118.2 153.550679 119.096443 154.557394 120.617538 154.8 122.34 156.05 129.99 145.19 143.13 144.73 143.68L143.19 142.4C143.3 142.27 153.93 129.4 152.82 122.66 152.676445 121.506701 152.003519 120.48622 151 119.9 149.73 119.12 147.83 119.83 146.47 120.58 139.83 124.17 129.58 137.3 129.27 148.91 129.13 154.34 131.27 158.44 135.63 161.12 154.32 172.57 177.12 151.36 177.35 151.12L178.73 152.57C178.55 152.78 163.8 166.51 147.8 166.51zM101.66 232.05C101.66 232.05 102.29 220.05 119.34 213.74L114.92 206.8C114.92 206.8 102.92 212.48 96.61 223.21L101.66 232.05zM187.52 198L187.52 207.47C187.52 207.47 201.41 203 212.14 210L215.3 203C215.3 203 207.72 194.17 187.52 198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3AA",
    d: "M271.48,240.26 C273.28,239.19 275.1,238.18 276.93,237.19 C278.76,236.2 280.6,235.26 282.45,234.32 C284.3,233.38 286.16,232.45 288.04,231.58 C289.92,230.71 291.78,229.78 293.67,228.94 L295.92,227.94 L295.53,230.35 C295.208641,232.456924 294.627551,234.515932 293.8,236.48 C292.995198,238.496378 291.840824,240.354885 290.39,241.97 C288.879286,243.659745 286.880206,244.837524 284.67,245.34 C282.509257,245.767125 280.272232,245.583592 278.21,244.81 L276.56,244.25 L277.99,243.4 C279.3,242.63 280.63,241.89 281.99,241.15 C283.35,240.41 284.67,239.69 285.99,239 C284.83,240 283.65,241 282.46,241.91 C281.27,242.82 280.07,243.8 278.86,244.71 L278.63,243.3 C279.555292,243.487216 280.496039,243.587652 281.44,243.6 C282.347833,243.616272 283.252474,243.488002 284.12,243.22 C285.834279,242.671184 287.347822,241.627362 288.47,240.22 C289.659611,238.776695 290.611554,237.152991 291.29,235.41 C291.996046,233.642513 292.528552,231.81056 292.88,229.94 L294.74,231.34 C292.85,232.18 290.93,232.97 289.01,233.76 C287.09,234.55 285.16,235.3 283.23,236.06 C281.3,236.82 279.35,237.54 277.39,238.24 C275.43,238.94 273.48,239.64 271.48,240.26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4CE",
    d: "M227.92,343.79 L245.6,340 C245.6,340 239.92,358.94 227.92,343.79 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3AA",
    d: "M157.54,223.65 L168.61,281.74 C168.61,281.74 154.55,278.36 151.79,285.74 C149.03,293.12 164.39,294.14 164.39,294.14 C164.39,294.14 169.72,312.93 179.1,310.95 C189.1,308.85 186.98,289.95 186.98,289.95 C186.98,289.95 197.22,285.78 195.38,278.4 C193.54,271.02 179.03,279.13 179.03,279.13 L167,221 L157.54,223.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C82",
    d: "M396.17 220.5L378.48 215.67 378.64 215.03C378.76 214.49 381.84 201.83 389.79 203.42 397.74 205.01 396.31 219.1 396.25 219.69L396.17 220.5zM380.17 214.7L394.98 218.7C395.15 215.78 395.28 205.87 389.55 204.7 383.82 203.53 380.85 212.25 380.14 214.7L380.17 214.7zM497.52 246.35L476.67 241.54 477.03 240.78C477.25 240.31 482.48 229.26 490.29 230.03 498.1 230.8 497.59 244.94 497.56 245.54L497.52 246.35zM478.66 240.6L496.21 244.6C496.21 241.67 495.84 231.91 490.15 231.35 484.46 230.79 480 238.17 478.66 240.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.87,
    height: 8.87,
    x: 153.77,
    y: 451.07,
    fill: "#7C7C82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.48,
    cy: 457.35,
    fill: "#A3A3AA",
    rx: 2.39,
    ry: 3.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.74,
    cy: 479.98,
    fill: "#A3A3AA",
    rx: 1.96,
    ry: 3.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.22,
    cy: 502.17,
    fill: "#A3A3AA",
    rx: 1.96,
    ry: 3.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.95,
    cy: 445.59,
    fill: "#A3A3AA",
    rx: 3.48,
    ry: 2.39,
    transform: "rotate(-75.57 106.95 445.59)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.512,
    cy: 466.482,
    fill: "#A3A3AA",
    rx: 3.48,
    ry: 1.96,
    transform: "rotate(-75.57 106.512 466.482)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.419,
    cy: 486.936,
    fill: "#A3A3AA",
    rx: 3.05,
    ry: 1.96,
    transform: "rotate(-75.57 100.419 486.936)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.893,
    cy: 506.939,
    fill: "#A3A3AA",
    rx: 3.05,
    ry: 1.74,
    transform: "rotate(-75.57 93.893 506.939)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A3A3AA",
    opacity: 0.3,
    transform: "translate(210 250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.35,
    cy: 4.7,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.29,
    cy: 3.15,
    r: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.4,
    cy: 13.99,
    r: 2.48
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#A3A3AA",
    opacity: 0.3,
    transform: "translate(115 269)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.95,
    cy: 14.37,
    r: 2.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.68,
    cy: 2.67,
    r: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.24,
    cy: 14.13,
    r: 2.48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpad);
export default __webpack_public_path__ + "static/media/ipad.faa85382631d49c35c66e1cc8d3ab2dd.svg";
export { ForwardRef as ReactComponent };